import { User } from 'oidc-client';
import appUserManager from './login-config';
import requestInstance from '../../utils/instance-utils';
import { CookieHelper } from '../../utils/helper/cookie-helper';

interface IAuthUser {
    id_token?: string | undefined;
    access_token?: string | undefined;
    expires_at?: number;
    profile?: any;
}

export function authenticateUser(
    identityAccessToken: string | undefined,
    identityAccessTokenExpiration: number,
    accessToken?: string
) {
    return requestInstance.get('login', {
        headers: {
            authorization: `Bearer ${identityAccessToken}`,
            expiration: identityAccessTokenExpiration,
            ...(accessToken && { 'x-access-token': accessToken }),
        },
    });
}

export async function initiateLogin() {
    try {
        const fetchUserManager = await appUserManager();
        const forceLogin = CookieHelper.getCookie() === 'true';
        await fetchUserManager.signinRedirect({
            state: {
                originalRedirectUrl: window.location.pathname,
            },
            ...(forceLogin && {
                extraQueryParams: {
                    prompt: 'login',
                },
            }),
        });
    } catch (error) {
        handleError('Auth: initiate login error', error);
    }
}

export async function initiateLogout() {
    try {
        CookieHelper.setCookie();
        const fetchUserManager = await appUserManager();
        await fetchUserManager.signoutRedirect();
    } catch (error) {
        handleError('Auth: initiate logout error', error, true);
    }
}

export async function processLoginCallback() {
    try {
        const fetchUserManager = await appUserManager();
        const userInfo: User = await fetchUserManager.signinRedirectCallback();
        return await getUserInfo(userInfo);
    } catch (error) {
        return handleError('Auth: process login callback error', error);
    }
}

export async function getUserInfo(userInfo?: User) {
    let oAuthUser = userInfo;
    try {
        const fetchUserManager = await appUserManager();
        if (!userInfo) {
            oAuthUser = await fetchUserManager.signinRedirectCallback();
        }
        const {
            id_token: identityAccessToken,
            access_token: accessToken,
            expires_at: identityAccessTokenExpiration,
            profile: {
                email,
                given_name: firstName,
                family_name: lastName,
                id,
            },
        }: IAuthUser = { ...oAuthUser };
        return {
            identityAccessToken,
            accessToken,
            identityAccessTokenExpiration,
            isUserAuthenticated: true,
            role: 'admin',
            email,
            firstName,
            lastName,
            originalRedirectUrl: oAuthUser?.state?.originalRedirectUrl,
            id,
        };
    } catch (error) {
        return handleError('Auth: set access token error', error);
    }
}

function handleError(errMsg: string, err: any, isUserAuthenticated?: boolean) {
    // gross but the linter wasnt accepting the old way
    // we should look into changing the linter because the previous approach was totally fine for NVC
    const error = new Error(errMsg);
    (error as any).isUserAuthenticated = isUserAuthenticated || false;
    (error as any).role = 'admin';
    (error as any).originalError = err;
    throw error;
}

export function isPOCRedirectValidAPI(ecrId: string) {
    return requestInstance.get(`/login/is-poc-redirect-valid/${ecrId}`);
}
